/* eslint-disable */
module.exports = require('./dist/isChromatic');
